// extracted by mini-css-extract-plugin
module.exports = {"addon":"currency-form-field_addon__Eb5Bu","wrapper":"currency-form-field_wrapper___OEbQ"};